export enum ErrorType {
    ReactErrorBoundary = 'ReactErrorBoundary',
    AsynchronousCode = 'AsynchronousCode',
    EventHandlers = 'EventHandlers'
}

export type TrackErrorBaseContext = {
    errorType: ErrorType;
};

export function trackError<E extends Error, C extends TrackErrorBaseContext>(
    error: E,
    context: C
): void {
    const caughtInPackage = '@dazn/lp-web';
    if (
        (window as any).newrelic &&
        typeof (window as any).newrelic.noticeError === 'function'
    ) {
        (window as any).newrelic.noticeError(error, {
            ...context,
            caughtInPackage
        });
    }
}
